export default {
  sendCustomEvent(event, val = 1) {
    if (process.env.NODE_ENV === 'production') {
      window.reportMsgObj[event] = val
      if (window.reportObserver) {
        window.reportObserver.forceCommit()
      }
    } else {
      console.log('[Event Send]', event, val)
    }
  },
}
